import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import { RoutePrivateProps } from 'components/Route/Private/types';

const ProductionForm = React.lazy(
  () => import('components/Production/Form/Form'),
);

function ScreensProductionForm(params: Readonly<RoutePrivateProps>) {
  return (
    <BaseLayout className="background-blue">
      <DocumentTitle>Edit Production</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <ProductionForm
          id={params.id ? parseInt(params.id as string, 10) : null}
          key={params.id}
        />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensProductionForm;
